import * as api from './FormsApi';
import { messages } from '../../lang/en';
import { getNamespace } from '../../utils/storage';
import * as type from './FormsType';

export const getFormStructure = (formType) => async (dispatch) => {
    const namespace = getNamespace();
    return await api.getFormStructure(formType, namespace).then((response) => {
        dispatch({
            type: type.GET_PATIENT_FORM_STRUCTURE,
            payload: response.data
        });
    });
};
export const getAllFormStructure = () => async (dispatch) => {
    const namespace = getNamespace();
    return await api.getAllFormStructure(namespace).then((response) => {
        dispatch({
            type: type.GET_PATIENT_FORM_STRUCTURE,
            payload: response.data.form_structures
        });
    });
};
export const createFormInstance = (formType, patientId, form) => async (dispatch) => {
    const formParam = {
        patient_id: patientId,
        field_value_map: form
    };
    return await api.createForm(formType, formParam).then((response) => {
        dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: messages.postActionAlert.formSubmitted,
                status: response.status
            }
        });
        dispatch({
            type: type.ADD_PATIENT_FORM,
            payload: response.data
        });
    });
};
export const getPatientForms = (patientId, formType) => async (dispatch) => {
    dispatch({
        type: type.GET_PATIENT_FORMS,
        payload: null
    });
    return await api.getPatientForms(patientId, formType).then((response) => {
        dispatch({
            type: type.GET_PATIENT_FORMS,
            payload: response.data.forms
        });
    });
};
export const editForm = (formId, form) => async (dispatch) => {
    const param = { field_value_map: form };
    return await api.editForm(formId, param).then((response) => {
        dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: messages.postActionAlert.formEdited,
                status: response.status
            }
        });
        dispatch({
            type: type.REPLACE_PATIENT_FORM,
            payload: response.data
        });
    });
};
export const deleteForm = (formId) => async (dispatch) => {
    return await api.deleteForm(formId).then((response) => {
        dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: messages.postActionAlert.formDeleted,
                status: response.status
            }
        });
        dispatch({
            type: type.REMOVE_PATIENT_FORM,
            payload: formId
        });
    });
};
